<template>
  <Container type="card-full" drankColor>
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">手机</div>
          <div class="field">
            <el-input v-model.trim="query.usercode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">姓名</div>
          <div class="field">
            <el-input v-model.trim="query.username" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">部门</div>
          <div class="field">
            <el-select v-model="query.userdptid" :clearable="true" placeholder="请选择">
              <el-option v-for="item in dptList"  :key="item.index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false"
            :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick"
            @cellDblClick="viewProject" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
      >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  import _ from 'lodash'
  export default {
    name: 'userIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        dptList: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          // { field: 'usercode', fieldtype: 'C', title: '账号',calculExpr:'', addNewRowFlg: false},
          { field: 'username', fieldtype: 'C', title: '姓名',calculExpr:'',addNewRowFlg: false},
          { field: 'usercode', fieldtype: 'C',title: '账号',calculExpr:'',addNewRowFlg: false},
          { field: 'usermobile', fieldtype: 'C',title: '手机',calculExpr:'',addNewRowFlg: false},
          { field: 'dptname', fieldtype: 'C', title: '部门',calculExpr:'',addNewRowFlg: false},
          { field: 'usertel', fieldtype: 'C',title: '电话',calculExpr:'',addNewRowFlg: false},
          { field: 'userremark', fieldtype: 'C',title: '备注',calculExpr:'',addNewRowFlg: false},
          { field: 'roleflgdesc', fieldtype: 'C',title: '授权',calculExpr:'',addNewRowFlg: false},
          { field: 'userstateDesc', fieldtype: 'C',title: '状态',calculExpr:'',addNewRowFlg: false}
        ],
        user: {},
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          comid: this.$store.getters.loginUser.usercomid,
          userid: this.$store.getters.loginUser.userid,
          comtype: this.$store.getters.loginUser.comtype,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addUser())
      this.$on('CHG', () => this.chgUser())
      this.$on('DEL', () => this.delUser())
      this.$on('RESET', () => this.resetPassword())
      this.$on('AUTH', () => this.authRole())
      this.$on('STOP', () => this.stopuser())
      // this.$on('CLOSE', () => this.close())
    },
    activated() {
      // this.query = {
      //   cosid: this.$store.getters.loginUser.cosid,
      //   comid: this.$store.getters.loginUser.usercomid,
      //   userid: this.$store.getters.loginUser.userid,
      //   comtype: this.$store.getters.loginUser.comtype,
      //   total: 0,
      //   limit: 20,
      //   offset: 0
      // }
      this.getDptList()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
        this.getPageList()
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      async getDptList () {
        let res = await request({
          method: 'get',
          url: '/xtgl/dpt/getDptList',
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
        this.dptList = res
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.user = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addUser () {
        let form = {
          userid: 0,
          usercomid: this.$store.getters.loginUser.usercomid,
          comtype:this.$store.getters.loginUser.comtype,
          userstatus: '1',
          userlockflg: '1'
        }
        this.$router.push({name: 'userForm', params: {form: form, type: 1}})
      },
      async chgUser () {
        if (!this.user.userid) {
          this.$message.warning('请选择一个用户!')
          return
        }
        this.user.cosid = this.$store.getters.loginUser.cosid
        this.$router.push({name: 'userForm', params: {form: this.user, type: 2}})
      },
      async authRole () {
        if (!this.user.userid) {
          this.$message.warning('请选择一个用户!')
          return
        }
        this.$router.push({name: 'userRoleForm', params: {form: this.user}})
      },
      async delUser () {
        if (!this.user.userid) {
          this.$message.warning('请选择一个用户!')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/user/delUser',
            method: "post",
            data: this.user
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          }
        })
      },
      async resetPassword () {
        if (!this.user.userid) {
          this.$message.warning('请选择一个用户!')
          return
        }
        this.$confirm('确定重置密码?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/user/resetPassword',
            method: "post",
            data: this.user
          })
          if (data.issuccess===1) {
            this.$message.success('重置密码成功,重置后密码为:888888')
          } else {
            this.$message.error('重置密码失败！')
          }
        })
      },
      async stopuser(){
        if (!this.user.userid) {
          this.$message.warning('请选择一个用户!')
          return
        }
        let msg = ''
        msg = +this.user.userstate === 1?"禁用":"启用"

        this.$confirm(`你是否要${msg}该用户?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          if(+this.user.userstate === 1){
            this.user.usercode = 'T'+this.user.usercode
          } else {
            this.user.usercode = _.trim(this.user.usercode,'T');
          }

          let data = await request({
            url: '/xtgl/user/stopuser',
            method: "post",
            data: {
              userstate:+this.user.userstate === 1? 2: 1,//启用状态就禁用用户
              usercode:this.user.usercode,
              userid:this.user.userid
            }
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success(`${msg}成功`)
          } else {
            this.$message.error(`${msg}失败！`)
          }
        })

      },
      handleSizeChange (btnPage) {
        this.query.offset = btnPage.pageSize * (btnPage.currentPage - 1)
        this.query.limit = btnPage.pageSize
        this.getPageList()
      },
      handleCurrentChange (btnPage) {
        this.query.offset = btnPage.pageSize * (btnPage.currentPage - 1)
        this.query.limit = btnPage.pageSize
        this.getPageList()
      },
      async save () {
        await request({
          url: '/xtgl/user/addOrEdit',
          method: "post",
          data: this.user
        })
        this.$message.success('操作成功')
        if (!this.user.userid) {
          this.query.currPage = 1
        }
        await this.getPageList()
      },
      async cellClick (row) {
        this.user = row.row
      },
      async viewProject(row) {
        this.user = row.row
        this.$router.push({name: 'userForm', params: {form: this.user,innerbtn: this.btn.inner, type: 3}})
      },
      async pagechange (userPage) {
        this.query.offset = userPage.pageSize * (userPage.currentPage - 1)
        this.query.limit = userPage.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        // this.query.userid = this.$store.getters.loginUser.userid
        // this.query.adminflag = this.$store.getters.loginUser.adminflag
        let res = await request({
          method: 'get',
          url: '/xtgl/user/getComuserList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    }
  }
</script>
<style lang="scss">

</style>
